import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import RadioGroup from './common/RadioGroup.jsx';

export default class GearModelEditComponent extends React.Component {

	componentDidMount() {
		this.props.findAllModelSizeTypes();
	}

	editItem() {
		this.props.editItem(this.props.gearModel, {
			activePage: this.props.activePage,
			itemPerPage: this.props.itemPerPage
		}, this.props.forInsert);
	}

	checkIsOthers(sizeType) {
		return this.props.allSizeTypes.some((value) => {
			return (
				sizeType === value.get('size_type') &&
				value.get('is_others') === 'Y'
			);
		});
	}

	render() {
		return (
			<div>
				<Row>
					<Col xs={2} sm={2} md={2}>
						<Button onClick={(event) => {
							this.editItem();
						}} bsStyle="info">
							Submit
						</Button>
					</Col>
					<Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} sm={12}>
						<RadioGroup
							id="companyType"
							label="公司"
							radioList={[{ label: "台灣開廣", value: 1 }, { label: "固巧快", value: 2 }]}
							value={this.props.gearModel.get('companyType')}
							onChange={(id, value) => {
								this.props.setValue(id, parseInt(value, 10));
							}}
							validation={this.props.gearModelValidation.get('companyType')}
							required="true"
						/>
					</Col>
					<Col xs={12} sm={12}>
						<RadioGroup
							id="sizeType"
							label="類型"
							radioList={this.props.allSizeTypes.map((value, key) => ({ label: value.get('display'), value: value.get('size_type') })).toJS()}
							value={this.props.gearModel.get('sizeType')}
							onChange={(id, value) => {
								this.props.setValue(id, parseInt(value, 10));
								if (this.checkIsOthers(parseInt(value, 10))) {
									this.props.setValue('sizeTypeIsOthers', 'Y');
								} else {
									this.props.setValue('sizeTypeIsOthers', '');
								}
							}}
							validation={this.props.gearModelValidation.get('sizeType')}
							required="true"
						/>
					</Col>
				</Row>
				<hr />
				<Row>
					<Col xs={12} sm={12} md={12}>
						<FieldGroup
							id="modelDisplayName"
							type="text"
							label="型號顯示名稱(僅辨識用)"
							value={this.props.gearModel.get('modelDisplayName')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.gearModelValidation.get('modelDisplayName')}
						/>
						<FieldGroup
							id="modelName"
							type="text"
							label="組合/型號 Model Name"
							value={this.props.gearModel.get('modelName')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.gearModelValidation.get('modelName')}
						/>
						{(this.props.gearModel.get('sizeTypeIsOthers') != 'Y') && (
							<div>
								<FieldGroup
									id="style"
									type="text"
									label="款式 Style"
									value={this.props.gearModel.get('style')}
									placeholder=""
									required="true"
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('style')}
								/>
								<FieldGroup
									id="certificates"
									type="text"
									label="符合認證 Certificates"
									value={this.props.gearModel.get('certificates')}
									placeholder=""
									required="true"
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('certificates')}
									componentClass="textarea"
									rows="3"
								/>
								<FieldGroup
									id="reinforcingFabric"
									type="text"
									label="Reinforcing Fabric"
									value={this.props.gearModel.get('reinforcingFabric')}
									placeholder=""
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('reinforcingFabric')}
									componentClass="textarea"
									rows="3"
								/>
								<FieldGroup
									id="outerShell"
									type="text"
									label="Outer Shell"
									value={this.props.gearModel.get('outerShell')}
									placeholder=""
									required="true"
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('outerShell')}
									componentClass="textarea"
									rows="3"
								/>
								<FieldGroup
									id="moistureBarrier"
									type="text"
									label="Moisture Barrier"
									value={this.props.gearModel.get('moistureBarrier')}
									placeholder=""
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('moistureBarrier')}
									componentClass="textarea"
									rows="3"
								/>
								<FieldGroup
									id="thermalLiners"
									type="text"
									label="Inner Lining"
									value={this.props.gearModel.get('thermalLiners')}
									placeholder=""
									required="true"
									onChange={(id, value) => {
										this.props.setValue(id, value);
									}}
									validation={this.props.gearModelValidation.get('thermalLiners')}
									componentClass="textarea"
									rows="3"
								/>
							</div>
						)}
					</Col>
				</Row>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/GearModelEditComponent.jsx